document.addEventListener('DOMContentLoaded', function() {
	if (document.querySelector('.main_prd_slider')) {

      $('.main__slider__prd').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: true,
        asNavFor: $('.main_thumbnail-content'),
      });
      
      $('.main_thumbnail-content').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: $('.main__slider__prd'),
        dots: false,
        centerMode: false,
        focusOnSelect: true,
        vertical: true,
        arrows: false,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              vertical: false
            }
          }
        ]
      });
		
		// const allVariantDiv = document.querySelectorAll('.row_variant');
		// variant metafield slider
		// for (let i = 0; i < allVariantDiv.length; i++) {
		// 	let vId = allVariantDiv[i].getAttribute('var_id');
		// 	let sliderDiv = document.querySelector(`.variant_${vId}`);

		// 	let sliderMain = sliderDiv.querySelector('.main__slider.main__slider__prd') ? sliderDiv.querySelector('.main__slider') : sliderDiv.querySelector('.main__slider .js-product-media-item');
      
		// 	let sliderNav = sliderDiv.querySelector('.main_thumbnail-content-variant');

		// 	// Check if sliderDiv is not null or undefined before proceeding
		// 	if (sliderDiv) {
		// 		$(sliderMain).slick({
		// 			slidesToShow: 1,
		// 			slidesToScroll: 1,
		// 			arrows: true,
		// 			fade: true,
		// 			asNavFor: sliderNav,
		// 		});

		// 		$(sliderNav).slick({
		// 			slidesToShow: 4,
		// 			slidesToScroll: 1,
		// 			asNavFor: sliderMain,
		// 			dots: false,
		// 			centerMode: false,
		// 			focusOnSelect: true,
		// 			vertical: true,
		// 			arrows: false,
		// 			responsive: [
		// 				{
		// 					breakpoint: 767,
		// 					settings: {
		// 						vertical: false
		// 					}
		// 				}
		// 			]
		// 		});

		// 	}

		// }

		// default theme slider
		// $('.product_media_v2 .main__slider').slick({
		// 	slidesToShow: 1,
		// 	slidesToScroll: 1,
		// 	arrows: true,
		// 	fade: true,
		// 	asNavFor: '.main_thumbnail-content-variant-v2'
		// });

		// $('.product_media_v2 .main_thumbnail-content-variant-v2').slick({
		// 	slidesToShow: 4,
		// 	slidesToScroll: 1,
		// 	asNavFor: '.product_media_v2 .main__slider',
		// 	dots: false,
		// 	centerMode: false,
		// 	focusOnSelect: true,
		// 	vertical: true,
		// 	arrows: false,
		// 	responsive: [
		// 		{
		// 			breakpoint: 767,
		// 			settings: {
		// 				vertical: false
		// 			}
		// 		}
		// 	]
		// });

		// get variant id
		// function getVariant() {
		// 	let queryString = window.location.search;

		// 	if (queryString.includes('variant')) {
		// 		let urlParams = new URLSearchParams(queryString);
		// 		// Get the value of the 'variant' parameter
		// 		let variantParam = urlParams.get('variant');
		// 		// remove ShowSlider class
		// 		document.querySelector('.ShowSlider') ? document.querySelector('.ShowSlider').classList.remove("ShowSlider") : null;
		// 		// add ShowSlider class
		// 		document.querySelector(`[var_id="${variantParam}"]`) ? document.querySelector(`[var_id="${variantParam}"]`).classList.add("ShowSlider") :
		// 		document.querySelector('.product_media_v2').classList.add("ShowSlider");
		// 	} else {
		// 		// remove ShowSlider class
		// 		document.querySelector('.ShowSlider') ? document.querySelector('.ShowSlider').classList.remove("ShowSlider") : null;
		// 		// add ShowSlider class
		// 		document.querySelector('.main_prd_slider').classList.add("ShowSlider");
		// 	}
		// }
		// getVariant();

		// const inputSwatch = document.querySelectorAll('.js-single-option-selector');
		// inputSwatch.forEach(elm => {
		// 	elm.addEventListener("change", function() {
		// 		setTimeout(() => {
		// 			getVariant();
		// 		}, 0);
		// 	});
		// });


		function openPhotoSwipe(index, parentDiv) {
			let items = [];
			// current variant img
			let pswImg = parentDiv.querySelectorAll('.product_media_v2 .main__slider .product-media__wrapper img')

			pswImg.forEach(elm => {
				let imgPath = {
					src: elm.src,
					w: elm.naturalWidth,
					h: elm.naturalHeight
				};
				items.push(imgPath);
			});

			var options = {
				index: index,
				bgOpacity: 0.85,
				showHideOpacity: true
				// Add more PhotoSwipe options as needed
			};

			var gallery = new PhotoSwipe(document.querySelector('.pswp'), PhotoSwipeUI_Default, items, options);
			gallery.init();
      }

		// all variants images
		const sliderImg = document.querySelectorAll('.main_prd_slider .main__slider .product-media__wrapper');
		sliderImg.forEach(elm => {
			elm.addEventListener("click", function(){
				let imgIndex = this.querySelector('img').getAttribute('data-number');
				let parent = this.closest('.main_prd_slider');
				openPhotoSwipe(imgIndex,parent)
				// console.log('varaints img');
			});
		})




    // change select box value through input radio
    const radioInputs = document.querySelectorAll('.custom_var_swatch')?.forEach(radioInput => {
        radioInput.addEventListener('change', function() {
            const selectBox = this.closest('.variants__options').querySelector('.js-single-option-selector');
            selectBox.value = this.value;
            selectBox.dispatchEvent(new Event('change'));
            imgGalleryHandle();
        });
    });
  

    const imgGalleryHandle = (element) => {
      setTimeout(() => {
        const metaSlider = document.querySelector('.variant_metafiled_slider');
        const variantId = document.querySelector('.main_select_box').value;
        const defaultSlider = document.querySelector('.main_prd_slider');

        // console.log('metaSlider', metaSlider);
        // console.log('variantId', variantId);
        // console.log('defaultSlider', defaultSlider);
        
        if (!variantId) return;
  
        let selectedVar;
        document.querySelectorAll('input[var_id]')?.forEach(inputElement => {
            let varIds = inputElement.getAttribute('var_id').split(',');
            if (varIds.includes(variantId)) {
              selectedVar = inputElement;
            }
        });
  
        if (!selectedVar) return;
        
        const galleryAttr = selectedVar.getAttribute('var_img_gallery');
        defaultSlider.style.display = galleryAttr ? 'none' : 'flex';
        galleryAttr ? null : $('.main__slider__prd').slick('refresh');
        galleryAttr ? null : $('.main_thumbnail-content').slick('refresh');
        metaSlider.style.display = galleryAttr ? 'flex' : 'none';
  
        if (!galleryAttr) return;

        const gallery = galleryAttr.split(',');
        const metaSliderInner = metaSlider.querySelector('.main_media-content');
        metaSliderInner.innerHTML = `<div class="var__slider__prd main__slider"></div>`;
        
        const metaSliderInnerThumb = metaSlider.querySelector('.main_thumbnail-content_var');
        metaSliderInnerThumb.innerHTML = `<div class="var__slider__prd__thumb"></div>`;
        
        gallery.forEach( (imageUrl, index) => {
          document.querySelector('.var__slider__prd').innerHTML += `
            <div class="js-product-media-item product-single__media-item">
              <div class="js-product-media product-media">
                <div class="product-media__wrapper product-media__wrapper--image">
                  <img class="mfp-image fade-in lazyautosizes ls-is-cached lazyloaded" src="${imageUrl}" data-number="${index}" />
                  <div class="gallery-cursor"></div>
                </div>
              </div>
            </div>
          `;
          
          const modifiedUrl = imageUrl.includes('?') ? imageUrl + '&width=150' : imageUrl + '?width=150';
          document.querySelector('.var__slider__prd__thumb').innerHTML += `
            <div class="product-single__thumbnail-wrapper product-single__thumbnail-wrapper-no-variant">
              <div class="product-media__wrapper">
                <a href="javascript:void(0)" class="product-single__thumbnail product-single__thumbnail_variant" data-media="${modifiedUrl}">
                  <img class="product-image__thumb fade-in ls-is-cached lazyloaded" src="${modifiedUrl}" />
                </a>
              </div>
            </div>
          `;
        });
        
        
        $('.var__slider__prd').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            fade: true,
            asNavFor: $('.var__slider__prd__thumb'),
            
            responsive: [
                {
                breakpoint: 767,
                settings: { dots: true, arrows:false, fade:false }
                }
            ]
            });
        
        
        $('.var__slider__prd__thumb').slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          asNavFor: $('.var__slider__prd'),
          dots: false,
          centerMode: false,
          focusOnSelect: true,
          vertical: true,
          arrows: false,
          responsive: [
            {
              breakpoint: 767,
              settings: { vertical: true, arrows:false }
            }
          ]
        });
        
            // console.log(111)
            $('.var__slider__prd__thumb').slick('refresh');
        
       

        // all variants images
		const sliderImg = document.querySelectorAll('.variant_metafiled_slider .main__slider .product-media__wrapper');
		sliderImg.forEach(elm => {
			elm.addEventListener("click", function(){
				let imgIndex = this.querySelector('img').getAttribute('data-number');
				let parent = this.closest('.variant_metafiled_slider');
				openPhotoSwipe(imgIndex,parent)
				// console.log('varaints img');
			});
		})
        
      }, 10);
    };
    imgGalleryHandle();

  }
});